import { IAppRoute } from '../routes'

export interface IDataContext {
  registration: IRegistration
  setRegistration: React.Dispatch<React.SetStateAction<IRegistration>>
}

export interface IStepProps extends IAppRoute {
  formData: any
}

export type TCourses =
  | 'business'
  | 'tech'
  | 'vet-lins'
  | 'vet-amparo'
  | 'ec43c13f-2dfa-48fb-b35b-0662bd7ad0be'

export const courseTypesToNames = (type: TCourses) => {
  switch (type) {
    case 'business':
      return 'Business'
    case 'tech':
      return 'Tech'
    case 'vet-lins':
      return 'Vet Lins'
    case 'vet-amparo':
      return 'Vet Amparo'
    case 'ec43c13f-2dfa-48fb-b35b-0662bd7ad0be':
      return 'ec43c13f-2dfa-48fb-b35b-0662bd7ad0be'
  }
}

export interface IRegistration {
  jwt?: string
  steps: IStepProps[]
  candidate: any
  cpf?: string
  code?: string
  date?: string
  course?: TCourses
  courseYear?: number
  courseTypeId?: number
  minBirthdate?: string
  maxBirthdate?: string
  document?: string
  setCpf: (
    setState: React.Dispatch<React.SetStateAction<IRegistration>>,
    cpf: string
  ) => void
  setCandidate: (setState: any, candidate: any) => void
  setDocument: (
    setState: React.Dispatch<React.SetStateAction<IRegistration>>,
    document: string
  ) => void
  setCourse?: (setState: any, course: string) => void
  setCode: (setState: any, code: string) => void
  setDate: (setState: any, date: string) => void
  setJWT: (setState: any, jwt: string) => void
  getStep: (state: IRegistration, stepName: string) => IStepProps | undefined
  getStepPosition: (state: IRegistration, stepName: string) => number
  getPreviousStep: (
    state: IRegistration,
    stepName: string
  ) => IStepProps | undefined
  getLastFilledStep: (state: IRegistration) => IStepProps | undefined
  setFormData: (
    setState: React.Dispatch<React.SetStateAction<IRegistration>>,
    stepName: string,
    formData: any
  ) => void
  registration_code?: string
  setRegistrationCode: (setState: any, registration_code: string) => void
}

export const setCpf = (
  setState: React.Dispatch<React.SetStateAction<IRegistration>>,
  cpf: string
) =>
  setState((current) => ({
    ...current,
    cpf,
  }))

export const setDocument = (
  setState: React.Dispatch<React.SetStateAction<IRegistration>>,
  document: string
) =>
  setState((current) => ({
    ...current,
    document,
  }))

export const setCourse = (setState: any, course: string) =>
  setState((current: IRegistration) => ({
    ...current,
    course,
  }))

export const setRegistrationCode = (setState: any, registration_code: string) =>
  setState((current: IRegistration) => ({
    ...current,
    registration_code,
  }))

export const setFormData = (
  setState: React.Dispatch<React.SetStateAction<IRegistration>>,
  stepName: string,
  formData: any
) =>
  setState((current) => ({
    ...current,
    steps: current.steps.map((step) =>
      step?.name === stepName
        ? {
            ...step,
            formData,
          }
        : step
    ),
  }))

export const getStep = (
  state: IRegistration,
  stepName: string
): IStepProps | undefined =>
  state.steps?.find((step) => step?.name === stepName)

export const getStepPosition = (
  state: IRegistration,
  stepName: string
): number => state.steps.map((step) => step.name).indexOf(stepName)

export const getPreviousStep = (
  state: IRegistration,
  stepName: string
): IStepProps | undefined =>
  state.steps[state.getStepPosition(state, stepName) - 1]

export const getLastFilledStep = (
  state: IRegistration
): IStepProps | undefined => state.steps.reverse().find((step) => step.formData)

export const setCode = (setState: any, code: string) =>
  setState((current: IRegistration) => ({
    ...current,
    code,
  }))

export const setDate = (setState: any, date: string) =>
  setState((current: IRegistration) => ({
    ...current,
    date,
  }))

export const setCandidate = (setState: any, candidate: any) =>
  setState((current: IRegistration) => ({
    ...current,
    candidate,
  }))

export const setJWT = (setState: any, jwt: string) =>
  setState((current: IRegistration) => ({
    ...current,
    jwt,
  }))
